import { Answer } from '../../question/answer/Answer';
export class TrayTransform {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    reuseAnswers = new Map();
    microAnswerToAnswer(microAnswer) {
        const existing = this.reuseAnswers.get(microAnswer.id);
        if (existing) {
            return existing;
        }
        const createdAnswer = Answer.fromSerialized({ parent: this.app, ...microAnswer });
        createdAnswer.poseDate = microAnswer.completeDate.dateFromMysqlTimestamp;
        createdAnswer.completeDate = microAnswer.completeDate.dateFromMysqlTimestamp;
        createdAnswer.finishDate = microAnswer.completeDate.dateFromMysqlTimestamp;
        this.reuseAnswers.set(microAnswer.id, createdAnswer);
        return createdAnswer;
    }
    reuseAnswersForMini = new Map();
    funnelMiniQuestionToAnswer(miniQuestion) {
        const existing = this.reuseAnswersForMini.get(miniQuestion.id);
        if (existing) {
            return existing;
        }
        const createdAnswer = Answer.fromSerialized({ parent: this.app, question_id: miniQuestion.id });
        this.reuseAnswersForMini.set(miniQuestion.id, createdAnswer);
        this.reuseAnswers.set(createdAnswer.id, createdAnswer);
        return createdAnswer;
    }
    questionIdToAnswer(questionId) {
        // on initial boot
        const createdAnswer = Answer.fromSerialized({ parent: this.app, question_id: questionId });
        this.reuseAnswers.set(createdAnswer.id, createdAnswer);
        return createdAnswer;
    }
}
